'use client'
/**
 * Used to filter out WalletConnect wallets if user has already a WalletConnect wallet connected/linked
 * This is useful for multi-wallet on mobile, since WalletConnect doesn't work very well with multiwallet
 */
const createWalletConnectWalletsFilter = (userWallets) => {
    const hasWCWallet = userWallets.some((wallet) => wallet.connector.isWalletConnect);
    // If user doesn't have WC wallet, keep all wallets (return true)
    if (!hasWCWallet) {
        return () => true;
    }
    // If user has WC wallet, filter out other WC wallets
    return (walletOption) => !walletOption.walletConnector.isWalletConnect;
};

export { createWalletConnectWalletsFilter };
